import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { GuideSpecificDetailsCardComponent } from './guide-specific-details-card.component';

@NgModule({
    imports: [
        CommonModule,
        TranslateModule.forChild()
    ],
    declarations: [GuideSpecificDetailsCardComponent],
    exports:[GuideSpecificDetailsCardComponent]
})
export class GuideSpecificDetailsCardModule {}
